import _ from "lodash";
import { AssignInvoiceCriteriaConstant } from "presentation/constant/AssignInvoiceCriteria/AssignInvoiceCriteriaConstant";
import { useAssignInvoiceCriteriaVM } from "presentation/hook/AssignInvoiceCriteria/useAssignInvoiceCriteriaVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useAssignInvoiceCriteriaTracked } from "presentation/store/AssignInvoiceCriteria/AssignInvoiceCriteriaProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
const AssignInvoiceCriteriaPanel = () => {
    const [assignInvoiceCriteriaState] = useAssignInvoiceCriteriaTracked();
    const assignInvoiceCriteriaVM = useAssignInvoiceCriteriaVM();
    const { criteria, dynamicOptions } = assignInvoiceCriteriaState;
    const [isLoading, setIsLoading] = useState(false);
    const messageBarVM = useMessageBarVM();
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate } = anaInfoState;

    const memoSubChgTypeOptions = useMemo(() => {
        if (!criteria.chargeTypes || criteria.chargeTypes.length === 0) {
            const allCommonSubChgTypeOptions = Object.values(dynamicOptions.subChargeTypeDropdownOptions).flat();
            return _.orderBy(_.uniqBy(_.flatMap(_.concat(allCommonSubChgTypeOptions ?? [])), 'value'), 'dropdownLabel');
        }
        const groupOfSubChgTypeOptions = criteria.chargeTypes?.map(chgType => dynamicOptions.subChargeTypeDropdownOptions[chgType]);
        const commonSubChgTypeOptions = _.orderBy(_.uniqBy(_.flatMap(_.concat(groupOfSubChgTypeOptions ?? [])), 'value'), 'dropdownLabel');
        return commonSubChgTypeOptions;

    }, [criteria.chargeTypes, dynamicOptions.subChargeTypeDropdownOptions])

    const memoBillToCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "630px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={criteria.billToCompanys?.join(',')}
                fieldValue={criteria?.billToCompanys}
                fieldLabel={AssignInvoiceCriteriaConstant.BILL_TO_COMPANY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompanys'}
                maxLength={60}
                isMultipleDropDown={true}
                options={dynamicOptions.billToCompanyDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    assignInvoiceCriteriaVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [assignInvoiceCriteriaVM, criteria.billToCompanys, dynamicOptions.billToCompanyDropdownOptions])

    const memoTariffType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "630px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={criteria.tariffTypes?.join(',')}
                fieldValue={criteria?.tariffTypes}
                fieldLabel={AssignInvoiceCriteriaConstant.TARIFF_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffTypes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={dynamicOptions.tariffTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    assignInvoiceCriteriaVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [assignInvoiceCriteriaVM, criteria.tariffTypes, dynamicOptions.tariffTypeDropdownOptions])

    const memoChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "630px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={criteria.chargeTypes?.join(',')}
                fieldValue={criteria?.chargeTypes}
                fieldLabel={AssignInvoiceCriteriaConstant.CHARGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeTypes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={dynamicOptions.chargeTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    assignInvoiceCriteriaVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [assignInvoiceCriteriaVM, criteria.chargeTypes, dynamicOptions.chargeTypeDropdownOptions])

    const memoSubChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "630px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={criteria.subChargeTypes?.join(',')}
                fieldValue={criteria?.subChargeTypes}
                fieldLabel={AssignInvoiceCriteriaConstant.SUB_CHARGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'subChargeTypes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={memoSubChgTypeOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    assignInvoiceCriteriaVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [assignInvoiceCriteriaVM, criteria.subChargeTypes, memoSubChgTypeOptions])

    const memoContainerStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "630px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={criteria.containerStatus?.join(',')}
                fieldValue={criteria?.containerStatus}
                fieldLabel={AssignInvoiceCriteriaConstant.CONTAINER_STATUS}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'containerStatus'}
                maxLength={60}
                isMultipleDropDown={true}
                options={dynamicOptions.containerStatusDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    assignInvoiceCriteriaVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [assignInvoiceCriteriaVM, criteria.containerStatus, dynamicOptions.containerStatusDropdownOptions])

    const memoContainerSize = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "630px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={criteria.containerSizes?.join(',')}
                fieldValue={criteria?.containerSizes}
                fieldLabel={AssignInvoiceCriteriaConstant.CONTAINER_SIZE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'containerSizes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={dynamicOptions.containerSizeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    assignInvoiceCriteriaVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [assignInvoiceCriteriaVM, criteria.containerSizes, dynamicOptions.containerSizeDropdownOptions])

    const memoShipmentType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "630px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={criteria.shipmentTypes?.join(',')}
                fieldValue={criteria?.shipmentTypes}
                fieldLabel={AssignInvoiceCriteriaConstant.SHIPMENT_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'shipmentTypes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={dynamicOptions.shipmentTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    assignInvoiceCriteriaVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [assignInvoiceCriteriaVM, criteria.shipmentTypes, dynamicOptions.shipmentTypeDropdownOptions])

    const memoCustomerCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "630px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={criteria.customerCodes?.join(',')}
                fieldValue={criteria?.customerCodes}
                fieldLabel={AssignInvoiceCriteriaConstant.CUSTOMER_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'customerCodes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={dynamicOptions.customerCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    assignInvoiceCriteriaVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [assignInvoiceCriteriaVM, criteria.customerCodes, dynamicOptions.customerCodeDropdownOptions])

    const memoDocDateFromTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <DateRangePickerComponent
                label={AssignInvoiceCriteriaConstant.DOC_DATE_RANGE}
                width='300px'
                fieldNames={{ startField: "docDateFrom", endField: "docDateTo" }}
                dateRange={{ startDate: criteria.docDateFrom, endDate: criteria.docDateTo }}
                onDatesChange={assignInvoiceCriteriaVM.onDateRangeChange}
            />
        </div>
        , [criteria.docDateFrom, criteria.docDateTo, assignInvoiceCriteriaVM.onDateRangeChange])

    const memoOpsDateFromTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <DateRangePickerComponent
                label={AssignInvoiceCriteriaConstant.OPS_DATE_RANGE}
                width='300px'
                fieldNames={{ startField: "opsDateFrom", endField: "opsDateTo" }}
                dateRange={{ startDate: criteria.opsDateFrom, endDate: criteria.opsDateTo }}
                onDatesChange={assignInvoiceCriteriaVM.onDateRangeChange}
            />
        </div>
        , [criteria.opsDateFrom, criteria.opsDateTo, assignInvoiceCriteriaVM.onDateRangeChange])

    const memoGlDateFromTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <DateRangePickerComponent
                label={AssignInvoiceCriteriaConstant.GL_DATE_RANGE}
                width='300px'
                fieldNames={{ startField: "glDateFrom", endField: "glDateTo" }}
                dateRange={{ startDate: criteria.glDateFrom, endDate: criteria.glDateTo }}
                onDatesChange={assignInvoiceCriteriaVM.onDateRangeChange}
            />
        </div>
        , [criteria.glDateFrom, criteria.glDateTo, assignInvoiceCriteriaVM.onDateRangeChange])

    const handleSubmit = useCallback(async () => {
        if ((!criteria.billToCompanys || (criteria.billToCompanys && criteria.billToCompanys.length === 0)) &&
            (!criteria.tariffTypes || (criteria.tariffTypes && criteria.tariffTypes.length === 0)) &&
            (!criteria.chargeTypes || (criteria.chargeTypes && criteria.chargeTypes.length === 0)) &&
            (!criteria.subChargeTypes || (criteria.subChargeTypes && criteria.subChargeTypes.length === 0)) &&
            (!criteria.containerStatus || (criteria.containerStatus && criteria.containerStatus.length === 0)) &&
            (!criteria.containerSizes || (criteria.containerSizes && criteria.containerSizes.length === 0)) &&
            (!criteria.shipmentTypes || (criteria.shipmentTypes && criteria.shipmentTypes.length === 0)) &&
            (!criteria.customerCodes || (criteria.customerCodes && criteria.customerCodes.length === 0)) &&
            !criteria.docDateFrom && !criteria.docDateTo && !criteria.opsDateFrom &&
            !criteria.opsDateTo && !criteria.glDateFrom && !criteria.glDateTo) {
            messageBarVM.showError("Bill-To Company, Customer Code, Container Size, Container Status, Charge Type, Sub Charge Type, Shipment Type, Tariff Type, Ops Date Range, Doc Date Range, GL Date Range must input one of them at least.")
            return;
        }
        setIsLoading(true);
        assignInvoiceCriteriaVM.onSubmit(criteria).then((data) => {
            if (data.success) {
                if (data.data) {
                    setIsLoading(false);
                    messageBarVM.showError(data.data);
                    return;
                }
                setIsLoading(false);
                messageBarVM.showSuccess("Assign Invoice Successfully.");
                return;
            } else {
                setIsLoading(false);
                messageBarVM.showError("Assign Invoice Failed.");
                return;
            }
        });
    }, [assignInvoiceCriteriaVM, criteria, messageBarVM]);

    const handleClear = useCallback(async () => {
        assignInvoiceCriteriaVM.onResetClick();
    }, [assignInvoiceCriteriaVM]);

    return <>
        <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
            <HeaderTitle>{AssignInvoiceCriteriaConstant.TITLE}</HeaderTitle>
            {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
            <StyledAction className="tm-animated-wrapper">
                {allowUpdate && <><HPHButton label={"Submit"} size={'Small'} disabled={false} theme={'Primary'} onClick={handleSubmit} /></>}
                <HPHButton label={"Clear"} size={'Small'} disabled={false} theme={'Secondary'} onClick={handleClear} />
            </StyledAction>
        </Sidebarheader>
        <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
            <div className={'add-edit-form'} style={{ height: 'calc(100vh - 125px)', maxHeight: 'calc(100vh - 125px)' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <CriteriaItemContainer>
                            {memoBillToCompany}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoTariffType}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoChargeType}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoSubChargeType}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoContainerStatus}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoContainerSize}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoShipmentType}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoCustomerCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoDocDateFromTo}
                            {memoOpsDateFromTo}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoGlDateFromTo}
                        </CriteriaItemContainer>

                    </div>
                </div>
            </div>
        </StyledSidebar>
    </>
}

export default memo(AssignInvoiceCriteriaPanel);
